@if (data) {
  <div class="as-modal-container">
    <div class="icon-container">
      <mat-icon mat-dialog-close svgIcon="ic-close-green"></mat-icon>
    </div>
    <div class="texts">
      <p class="as-font as-font-16 as-font-blackish">{{ 'GENERAL.remember' | translate }}</p>
      <p class="as-font as-font-16 as-font-blackish">{{ 'GENERAL.remember1' | translate }}</p>
    </div>
    <div class="buttons-container">
      <button (click)="close(true)" mat-flat-button class="" color="accent">{{ 'GENERAL.changeDate' | translate }}</button>
      <button (click)="close(false)" color="accent">{{ 'GENERAL.ignore' | translate }}</button>
    </div>
  </div>
} @else {
  <div class="as-modal-container">
    <div class="icon-container">
      <mat-icon mat-dialog-close svgIcon="ic-close-green"></mat-icon>
    </div>
    <div class="texts">
      <p class="as-font as-font-16 as-font-blackish">{{ 'GENERAL.leaving' | translate }}</p>
      <p class="as-font as-font-16 as-font-blackish">{{ 'GENERAL.leaving1' | translate }}</p>
    </div>
    <div class="buttons-container">
      <button (click)="close(false)" mat-flat-button class="" color="accent">{{ 'GENERAL.create' | translate }}</button>
      <button (click)="close(true)" color="accent">{{ 'GENERAL.changeDate' | translate }}</button>
    </div>
  </div>
}
